import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import _, { find as _find } from 'lodash';
import { getCorporateDesignClient, getCorporateDesignLogoUrl } from 'cc-editor/helpers/corporateDesign';
const PreviewImageElementFTs = ({ name: Tag, attributes, params, srcThumb, settings, editionRV }) => {
    const getSrc = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const param = _find(params, ['name', attributes['data-name']]);
        if (srcThumb !== '' && srcThumb !== undefined) {
            return srcThumb;
        }
        if (param) {
            if (param.thumb) {
                return param.thumb;
            }
            return param.value;
        }
        if (attributes.src) {
            if (attributes.src === '{logoBlack}' || attributes.src === '{logoWhite}' || attributes.src === '{logoColored}') {
                const cdClient = getCorporateDesignClient(editionRV) || (settings === null || settings === void 0 ? void 0 : settings.target);
                if (attributes.src === '{logoBlack}') {
                    return getCorporateDesignLogoUrl(cdClient, 'client_main_logo')
                        || ((_e = (_d = (_c = (_b = (_a = settings === null || settings === void 0 ? void 0 : settings.target) === null || _a === void 0 ? void 0 : _a.client_main_logo) === null || _b === void 0 ? void 0 : _b.variations) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.file) === null || _e === void 0 ? void 0 : _e.web_link)
                        || '';
                }
                if (attributes.src === '{logoWhite}') {
                    return getCorporateDesignLogoUrl(cdClient, 'client_main_logo_white')
                        || ((_k = (_j = (_h = (_g = (_f = settings === null || settings === void 0 ? void 0 : settings.target) === null || _f === void 0 ? void 0 : _f.client_main_logo_white) === null || _g === void 0 ? void 0 : _g.variations) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.file) === null || _k === void 0 ? void 0 : _k.web_link)
                        || '';
                }
                return getCorporateDesignLogoUrl(cdClient, 'client_main_logo_multi_colored')
                    || ((_q = (_p = (_o = (_m = (_l = settings === null || settings === void 0 ? void 0 : settings.target) === null || _l === void 0 ? void 0 : _l.client_main_logo_multi_colored) === null || _m === void 0 ? void 0 : _m.variations) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.file) === null || _q === void 0 ? void 0 : _q.web_link)
                    || '';
            }
            return attributes.src;
        }
        return 'nopic.jpg';
    };
    const index = _.findIndex(params, (param) => param.name === attributes['data-name']);
    const _filter = params[index] && params[index].filter !== undefined ? params[index].filter : '';
    return (_jsx("div", { className: "editor-image-content dropbox", id: "test", children: _jsx(Tag, Object.assign({}, attributes, { src: getSrc(), style: { filter: _filter } })) }));
};
const mapStateToProps = (state) => {
    return {
        editionRV: state.editor.editionRV,
    };
};
export default connect(mapStateToProps)(PreviewImageElementFTs);
